import {useSyncExternalStore} from 'react';
import {Alert, LinearProgress, Stack, Typography} from '@mui/material';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {getImageUploadProgress, subscribeImageUploadProgress} from '../../services/ImageUploadProgress';

export const ImageUploadStatus = ({orderId, uploading, created = false}: {orderId: string; uploading: boolean; created?: boolean}) => {
    const {t} = useAppTranslation();
    const progress = useSyncExternalStore(subscribeImageUploadProgress, () => getImageUploadProgress(orderId));
    const percent = progress?.total ? Math.round(progress.completed / progress.total * 100) : 0;
    return <Alert severity="info" role="status" sx={{'& .MuiAlert-message': {width: '100%'}}}>
        <Stack spacing={1}>
            <Typography>{t((uploading ? created ? 'orders:photos_uploading_created' : 'orders:photos_uploading' : 'orders:photos_pending') as never)}</Typography>
            {progress && progress.total > 0 && <>
                <Typography>{String(t('orders:photos_upload_progress' as never, {completed: progress.completed, total: progress.total} as never)) + ' · ' + percent + '%'}</Typography>
                <LinearProgress variant="determinate" value={percent} aria-label={t('orders:images')}/>
            </>}
        </Stack>
    </Alert>;
};
